import { GlobalData } from "../../Common/GlobalData";
import { Notification, TemplateHelpers } from "../../Common/KendoHelpers";

export class BasesFormingDiffs {
    public static readonly GRID = '#grid';
    public static readonly DATE_PICKER = '#datePicker';
    public static readonly INCLUDE_SAME_BASE_TYPES = '#includeSameBaseTypes';

    private grid!: kendo.ui.Grid;

    constructor() {
        this.init();
    }

    private init() {
        this.grid = $(BasesFormingDiffs.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(this.getDataSourceOptions()),
            height: 915,
            groupable: false,
            editable: false,
            navigatable: false,
            sortable: true,
            filterable: true,
            pageable: false,
            resizable: true,
            columns: [
                {
                    title: 'General Info',
                    width: '25%',
                    headerAttributes: { class: 'table-header-cell grid-header-14 grid-column-group-separator' },
                    columns: [
                        {
                            field: 'symbol',
                            title: 'Symbol',
                            width: '6%',
                            filterable: false,
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                            template: kendo.template(TemplateHelpers.getSymbolLinkTemplate('StockChecklistReport?symbol=')),
                        },
                        {
                            field: 'companyName',
                            title: 'Company Name',
                            width: '16%',
                            filterable: false,
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: left; font-size: 12px' },
                        },
                        {
                            field: 'currentPrice',
                            title: 'Current<br>Price',
                            width: '8%',
                            filterable: true,
                            headerAttributes: { class: 'table-header-cell grid-header-12 grid-column-group-separator' },
                            attributes: { class: 'table-cell grid-column-group-separator', style: 'text-align: left; font-size: 12px' },
                        },
                    ],
                },
                {
                    title: 'Old Pattern',
                    width: '25%',
                    headerAttributes: { class: 'table-header-cell grid-header-14 grid-column-group-separator' },
                    columns: [
                        {
                            field: 'oldEventDate',
                            title: 'Event<br>Date',
                            width: '8%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: left; font-size: 12px' },
                            template: kendo.template(TemplateHelpers.getFormattedDateTemplate('oldEventDate')),
                        },
                        {
                            field: 'oldBase',
                            title: 'Base<br>Type',
                            width: '12%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                        },
                        {
                            field: 'oldBaseStage',
                            title: 'Base<br>Stage',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                        },
                        {
                            field: 'oldPctChangeVsPivot',
                            title: '% From<br>Pivot',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12 grid-column-group-separator' },
                            attributes: { class: 'table-cell grid-column-group-separator', style: 'text-align: center; font-size: 12px' },
                            format: '{0:p0}',
                        },
                    ],
                },
                {
                    title: 'New Pattern',
                    width: '25%',
                    headerAttributes: { class: 'table-header-cell grid-header-14', style: 'border-right: 1px solid black;' },
                    columns: [
                        {
                            field: 'newEventDate',
                            title: 'Event<br>Date',
                            width: '8%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: left; font-size: 12px' },
                            template: kendo.template(TemplateHelpers.getFormattedDateTemplate('newEventDate')),
                        },
                        {
                            field: 'newBase',
                            title: 'Base<br>Type',
                            width: '12%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                        },
                        {
                            field: 'newBaseStage',
                            title: 'Base<br>Stage',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                        },
                        {
                            field: 'newPctChangeVsPivot',
                            title: '% From<br>Pivot',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                            format: '{0:p0}',
                        },
                        {
                            field: 'reportDate',
                            title: 'Report<br>Date',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12 grid-column-group-separator' },
                            attributes: { class: 'table-cell grid-column-group-separator', style: 'text-align: center; font-size: 12px' },
                            template: kendo.template(TemplateHelpers.getFormattedDateTemplate('reportDate')),
                        },
                    ],
                },
                {
                    title: 'Technical',
                    width: '25%',
                    headerAttributes: { class: 'table-header-cell grid-header-14' },
                    columns: [
                        {
                            field: 'compositeRating',
                            title: 'Comp<br>Rating',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                        },
                        {
                            field: 'earningsPerShareRating',
                            title: 'EPS<br>Rating',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                        },
                        {
                            field: 'relativeStrengthRating',
                            title: 'RS<br>Rating',
                            width: '6%',
                            headerAttributes: { class: 'table-header-cell grid-header-12' },
                            attributes: { class: 'table-cell', style: 'text-align: center; font-size: 12px' },
                        },
                    ],
                },
            ]
        }).data('kendoGrid')!;

        this.defineEvents();
    }

    private defineEvents() {
        const self = this;

        $(BasesFormingDiffs.DATE_PICKER).kendoDatePicker({
            change: function () {
                self.grid.setDataSource(new kendo.data.DataSource(self.getDataSourceOptions()));
            }
        });

        $(BasesFormingDiffs.INCLUDE_SAME_BASE_TYPES).off('change').on('change', () => {
            this.grid.setDataSource(new kendo.data.DataSource(this.getDataSourceOptions()));
        });
    }

    private getDataSourceOptions() {
        return {
            transport: {
                read: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_BASES_FORMING_DIFFS +
                    '?startDate=' + $(BasesFormingDiffs.DATE_PICKER).val()!.toString() +
                    '&includeSameBaseTypes=' + 
                    $(BasesFormingDiffs.INCLUDE_SAME_BASE_TYPES).is(':checked')
            },
            error: () => {
                var notification = new Notification();
                notification.error('No data found to display');
            },
            schema: {
                model: {
                    fields: {
                        symbol: { type: 'string' },
                        companyName: { type: 'string' },
                        currentPrice: { type: 'number' },
                        newEventDate: { type: 'date' },
                        newBase: { type: 'string' },
                        newBaseStage: { type: 'string' },
                        newPctChangeVsPivot: { type: 'number' },
                        oldEventDate: { type: 'date' },
                        oldBase: { type: 'string' },
                        oldBaseStage: { type: 'string' },
                        oldPctChangeVsPivot: { type: 'number' },
                        reportDate: { type: 'date' },
                        compositeRating: { type: 'number' },
                        earningsPerShareRating: { type: 'number' },
                        relativeStrengthRating: { type: 'number' },
                    },
                },
            },
        };
    }
}
